__turbopack_context__.v({
  "className": "poppins_b86fc9b8-module__LGzp8G__className",
});
